import { type OpenApiSchemaCategory } from '../../api/schema';
import { sortCategories } from './sortCategories';

type PickedCategoryModel = Pick<OpenApiSchemaCategory, 'id' | 'parent_id' | 'title' | 'display_sequence'>;
export type CategoryWithParentsPath<M extends PickedCategoryModel> = M & { level: number; parentsPath: string };

export const enrichCategoriesWithParentPath = <M extends PickedCategoryModel>(
    categories: M[]
): CategoryWithParentsPath<M>[] => {
    const treeCategories = sortCategories(categories);

    const getParents = (parentsIds: Set<OpenApiSchemaCategory['id']>): string[] =>
        Array.from(parentsIds).reduce<string[]>((acc, parentId) => {
            const patentCategory = categories.find((category) => category.id === parentId);

            if (patentCategory) {
                acc.push(patentCategory.title);
            }

            return acc;
        }, []);

    return treeCategories.map(({ attributes: category, parentsIds, level }) => {
        return {
            ...category,
            level,
            parentsPath: [...getParents(parentsIds), category.title].filter(Boolean).join(' → '),
        };
    });
};
